import React from 'react';
import { IconProps } from '../types/types';

const MRK: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#009394" d="M0 0h18v18H0z"/><circle cx="9" cy="9" r="9" fill="#009394"/><path fillRule="evenodd" clipRule="evenodd" d="M9 4a2.5 2.5 0 00-2.5 2.5h5a2.5 2.5 0 11-5 0 2.5 2.5 0 000 5 2.5 2.5 0 015 0h-5a2.5 2.5 0 105 0 2.5 2.5 0 100-5A2.5 2.5 0 009 4zm2.5 2.5zm0 5z" fill="#fff"/></svg>
);

export default MRK;